import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, fields } from '../../../../src/helpers/LinkMapper';

const fieldSchema = {
    length: [ fields.string ],
    reason: [ fields.string ],
    additionalInformation: [ fields.string ]
};

export default class DelayRepayDelay extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(DelayRepayDelay, json, getResolvers(fieldSchema));
    }
}
